import React, { useEffect } from 'react';
import styles from './Countdown.module.scss';
import useCountdown from '../../../common/hooks/useCountdown';
import { useVoiceoverContext } from '../../context/VoiceoverContext';
import cx from 'classnames';

const deviation = 50;

const Countdown = ({ currentSeconds, duration }) => {
  const {
    voiceovers,
    isVoiceoverCountdown,
    changeIsVoiceoverCountdown,
    changeIsVoiceoverRecording,
    updateVoiceoverSeekValue,
  } = useVoiceoverContext();
  const { seconds, start, pause, reset } = useCountdown({
    initialSecond: 3,
    autoStart: false,
    onExpire: () => {
      changeIsVoiceoverRecording(true);
      changeIsVoiceoverCountdown(false);
    },
  });

  useEffect(() => {
    if (isVoiceoverCountdown) {
      const currentVoiceover =
        voiceovers?.find(
          ({ trimStartOffset, trimEndOffset, storyOffset }) =>
            storyOffset + trimStartOffset <= currentSeconds && storyOffset + trimEndOffset >= currentSeconds
        ) || {};

      if (currentVoiceover?.id) {
        updateVoiceoverSeekValue((currentVoiceover?.storyOffset + currentVoiceover?.trimEndOffset + deviation) / duration);
      }
      start();
    } else {
      reset();
    }
  }, [isVoiceoverCountdown]);

  return <div className={cx(styles.container, { [styles.active]: isVoiceoverCountdown })}>{seconds}</div>;
};

export default Countdown;
